import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr2012',
    ecrans: ['00-2'],
    params: ['dercleint']
});
